import { format, getDate, getMonth } from 'date-fns';
import { getFormattedDate } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';

interface GetAvailableDateRangeText {
  currentCycleStartDate: Date;
  endDateRangeInsideMonth: Date;
  isMultiMonthsLengthBudget: boolean;
  monthAvailableDaysCount: number;
}

export function getAvailableDateRangeText({
  currentCycleStartDate,
  endDateRangeInsideMonth,
  isMultiMonthsLengthBudget,
  monthAvailableDaysCount,
}: GetAvailableDateRangeText): string {
  const formattedMonthStart = format(currentCycleStartDate, 'do');
  const formattedCurrentCycleStartDate = getFormattedDate(
    currentCycleStartDate
  );
  const formattedEndDateRangeInsideMonth = getFormattedDate(
    endDateRangeInsideMonth
  );

  const isSameDate =
    getMonth(currentCycleStartDate) === getMonth(endDateRangeInsideMonth) &&
    getDate(currentCycleStartDate) === getDate(endDateRangeInsideMonth);

  if (isMultiMonthsLengthBudget && !isSameDate) {
    return `${monthAvailableDaysCount} ${getSingularOrPlural(
      monthAvailableDaysCount,
      'day'
    )} starting from the ${formattedMonthStart} of each month`;
  }

  if (isMultiMonthsLengthBudget && isSameDate) {
    return `${formattedMonthStart} of each month`;
  }

  if (isSameDate) {
    return `${formattedCurrentCycleStartDate}`;
  }

  return `${formattedCurrentCycleStartDate} - ${formattedEndDateRangeInsideMonth}`;
}
